import { render, staticRenderFns } from "./StatusLeilao.vue?vue&type=template&id=07286877&scoped=true&"
import script from "./StatusLeilao.vue?vue&type=script&lang=js&"
export * from "./StatusLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07286877",
  null
  
)

export default component.exports